// Generated by CoffeeScript 1.11.1

/**
Converts markdown string to html

@method markdownToHtml
@param {String} markdown markdown to convert
@param {Object} options marked options (https://github.com/chjj/marked#gfm)
@param {String} exclude tags to exclude: ex: '<a><img><span>'

@return {String} markdown string
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/markdown_to_html',['underscore', 'marked'], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory(require('underscore'), require('marked'));
  } else {
    return root.markdownToHtml = factory(root.underscore);
  }
})(this, function(_, marked) {
  var markdownToHtml;
  return markdownToHtml = function(markdown, options, exclude) {
    var html;
    options = _.defaults(options, {
      gfm: true,
      tables: false,
      breaks: true,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: true
    });
    marked.setOptions(options);
    if (markdown && markdown.length) {
      html = marked(markdown);
    }
    if (exclude && exclude.length && html && html.length) {
      html = html.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/g, function($0, $1) {
        if (exclude.indexOf("<" + $1.toLowerCase() + ">") > -1) {
          return "";
        } else {
          return $0;
        }
      });
    }
    if (html && html.length) {
      return html.trim();
    } else {
      return html;
    }
  };
});

